import React from 'react';

function GeneralRules() {
  return (
    <div className="centered-content" style={{
      maxWidth: 800,
      margin: '2rem auto',
      textAlign: 'left',
      background: 'rgba(255,255,255,0.97)',
      padding: '2rem',
      borderRadius: '1rem',
      boxShadow: '0 2px 16px rgba(0,0,0,0.08)'
    }}>
      <h2 style={{ textAlign: 'center', marginBottom: '1.5rem' }}>General Conditions &amp; Privacy Policy</h2>
      <h3 style={{ textAlign: 'center', marginTop: 0 }}>Seacloud Software - Salesforce Debug Extensions</h3>
      <p style={{ textAlign: 'center', fontStyle: 'italic', marginBottom: '2rem' }}>
        Version: v2.0.0
      </p>
      <hr />
      <h4>1. General Conditions</h4>
      <p>
        By downloading, installing, and/or using Seacloud Software Salesforce Debug Extensions (hereafter "Seacloud Extensions," "Application," or "Software"), you fully agree to these Terms and Conditions.
      </p>
      <p>
        Seacloud Software ("We," "Our," "Us") developed the Seacloud Extensions as a free Google Chrome Extension. This Application is provided at no cost and is intended for use "AS IS."
      </p>
      <hr />
      <h4>2. Privacy Policy</h4>
      <p>
        <b>No Data Collection:</b> Seacloud Software does not collect, store, or share your personal or Salesforce data with anyone.
      </p>
      <p>
        <b>Local Browser Storage:</b> This Application utilizes your browser's local storage mechanisms solely to save preferences, settings, query history, or similar items needed for enhancing usability and avoiding redundant operations. No sensitive Salesforce records (Accounts, Contacts, Opportunities, or other SObjects) or personal information are stored or transmitted externally by this extension.
      </p>
      <p>
        <b>Salesforce Communication:</b> Seacloud Extensions communicate directly with Salesforce servers via Salesforce's official API endpoints. Communication occurs on behalf of the logged-in Salesforce user, and the extension can only access Salesforce data and features explicitly permitted by the user's Salesforce profile, role, permissions, and configuration.
      </p>
      <p>
        <b>Third-party Integrations:</b> This Application utilizes Google's Chrome Extension and DevTools Extension APIs. By using Seacloud Extensions, you agree to Google's Privacy Policy and Google's Terms of Service. Additionally, by using this Application in conjunction with Salesforce, you agree to the Salesforce Privacy Policy and Salesforce Terms of Service.
      </p>
      <hr />
      <h4>3. Third-party Open Source Libraries</h4>
      <p>
        Seacloud Extensions may utilize third-party open-source libraries or frameworks, including but not limited to:
      </p>
      <ul>
        <li>JSforce: JavaScript library to interact with Salesforce APIs (<a href="https://github.com/jsforce/jsforce" target="_blank" rel="noopener noreferrer">https://github.com/jsforce/jsforce</a>)</li>
        <li>Additional third-party libraries licensed under MIT or Apache 2.0 Licenses.</li>
      </ul>
      <p>
        These libraries are integrated according to their licensing terms and conditions, and we acknowledge their respective licenses and intellectual property rights.
      </p>
      <hr />
      <h4>4. Warranties and Limitations of Liability</h4>
      <p>
        <b>Warranties Disclaimer</b><br />
        THIS APPLICATION IS PROVIDED "AS IS" WITHOUT WARRANTIES OR GUARANTEES OF ANY KIND, EXPRESS OR IMPLIED. SEACLOUD SOFTWARE MAKES NO WARRANTY REGARDING THE ACCURACY, COMPLETENESS, RELIABILITY, OR SUITABILITY OF THE APPLICATION OR ITS FUNCTIONALITIES.
      </p>
      <p>
        <b>Risk and Liability</b><br />
        Your use of Seacloud Extensions is solely at your own risk. Seacloud Software disclaims liability for any direct, indirect, incidental, consequential, or punitive damages, including but not limited to data loss, damages, interruptions, inaccuracies, or errors arising out of your use or inability to use the Application.
      </p>
      <p>
        Seacloud Software will not be held responsible for any damages including loss of profits, business opportunities, revenue, or data loss caused directly or indirectly by your use of the Application.
      </p>
      <hr />
      <h4>5. Intellectual Property Rights</h4>
      <p>
        All materials included in Seacloud Extensions, including logos, names, graphics, user interfaces, source code, design elements, and other intellectual property, are the exclusive property of or licensed to Seacloud Software unless otherwise explicitly stated.
      </p>
      <p>
        The Application utilizes the Salesforce Lightning Design System (SLDS) resources according to Salesforce's usage terms and licensing conditions. For further information, visit <a href="https://lightningdesignsystem.com" target="_blank" rel="noopener noreferrer">https://lightningdesignsystem.com</a>.
      </p>
      <hr />
      <h4>6. Trademark Notice</h4>
      <p>
        Salesforce® is a registered trademark of Salesforce.com, Inc.<br />
        Seacloud Software and Seacloud Software Salesforce Debug Extensions are not affiliated with, endorsed, sponsored, or supported by Salesforce.com, Inc. All other trademarks referenced herein are the property of their respective owners.
      </p>
      <hr />
      <h4>7. Modifications and Updates</h4>
      <p>
        We reserve the right, at our sole discretion, to update, modify, or discontinue the Application or any part thereof at any time without prior notice. You are responsible for regularly reviewing these Terms and Conditions and Privacy Policy. Your continued use of the Application following any changes signifies your acceptance of such changes.
      </p>
      <hr />
      <h4>8. Reasonableness Clause</h4>
      <p>
        By using Seacloud Extensions, you explicitly agree that the limitations and exclusions of liability set forth above are reasonable. If you disagree with these conditions, you must discontinue use immediately.
      </p>
      <hr />
      <h4>9. Changes to Privacy Policy and Terms of Use</h4>
      <p>
        We may periodically update our Privacy Policy and Terms of Use. Users are advised to review this page regularly for changes. All updates will be communicated clearly within the Application or through standard update mechanisms provided by the Chrome Web Store.
      </p>
      <hr />
      <h4>10. Contact Information</h4>
      <p>
        If you have questions, concerns, or suggestions regarding our Privacy Policy or these Terms and Conditions, please reach out via:<br />
        • Email: <a href="mailto:support@seacloud-software.hr">support@seacloud-software.hr</a><br />
        • Website: <a href="https://seacloud-software.hr" target="_blank" rel="noopener noreferrer">https://seacloud-software.hr</a> <br/>
        • About us: <a href="https://seacloud-software.hr/legal" target="_blank" rel="noopener noreferrer">https://seacloud-software.hr/legal </a>

      </p>
      <p>We strive to respond promptly to all inquiries.</p>
      <hr />

      <p style={{ textAlign: 'center', fontWeight: 600 }}>
        Seacloud Software<br />
        Website: <a href="https://seacloud-software.hr" target="_blank" rel="noopener noreferrer">https://seacloud-software.hr</a>
      </p>
      <p style={{ textAlign: 'center' }}>
        Thank you for choosing Seacloud Software Salesforce Debug Extensions.
      </p>
    </div>
  );
}

export default GeneralRules;